var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.getMembershipRenewalMessage)?_c('TixMessage',{attrs:{"template":_vm.getMembershipRenewalMessage}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }